/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  getAttend({ commit }, workspaceId) {
    return new Promise((resolve, reject) => {
      axios.get("/api/workspace/insight/attend/"+workspaceId)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('SET_ATTEND', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getReport({commit}, workspaceId){
    return new Promise((resolve, reject) => {
      axios.get("/api/workspace/insight/submit/"+workspaceId)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('SET_REPORT_RESULT', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getTestResult({commit}, workspaceId){
    return new Promise((resolve, reject) => {
      axios.get("/api/workspace/insight/test/"+workspaceId)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('SET_TEST_RESULT', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getProjectInsight({commit}, workspaceId){
    return new Promise((resolve, reject) => {
      axios.get("/api/workspace/insight/projects/"+workspaceId)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('SET_PROJECT_INFO_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getProjectTeamInfo(context, projectId){
    return new Promise((resolve, reject) => {
      axios.get("/api/workspace/insight/project/team/"+projectId)
        .then((response) => {
          if(response.data.result == 'success'){
            // console.log(response.data.data_list)
            // commit('SET_PROJECT_INFO_LIST', response.data.data_list)
            resolve(response.data.data_list)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  setProjectTeamScore(context, payload){
    return new Promise((resolve, reject) => {
      axios.post("/api/workspace/insight/project/score", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  setProjectMemberScore(context, payload){
    return new Promise((resolve, reject) => {
      axios.post("/api/workspace/insight/project/member/score", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error)})
    })
  },
  getUserJoinType({
    commit
  }){
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/user-join-type")
        .then((response) => {
          console.log(response)
          if(response.data.result == 'success'){
            commit('GET_JOIN_TYPE', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getUserJoinMonth({commit} , payload){
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/insight/user-join/month/" + payload.date)
        .then((response) => {
          console.log(response)
          if(response.data.result == 'success'){
            commit('GET_JOIN_MONTH', response.data.data_list)
            resolve(payload)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
